import rtlLanguages from '../assets/rtl_languages.json';

export const isRtl = (lioLocaleId: number | undefined) => {
	const index = rtlLanguages.findIndex((i) => i.id === lioLocaleId);
	return index !== -1;
};
